
import {
    VOTING_TICKET_MODAL_OPEN,
    VOTING_TICKET_MODAL_CLOSE
} from '../constants/actionTypes';

export const votingTicketModalOpen = payload => ({
    type: VOTING_TICKET_MODAL_OPEN,
    payload
});

export const votingTicketModalClose = () => ({
    type: VOTING_TICKET_MODAL_CLOSE
});